import React, { useCallback, useMemo, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";
import NoteTable from "../../common_nextgen/common_components/NoteScreenComponents/NoteTable";
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import { ROUTE_PATHS } from "../../common_nextgen/utils/Constants.js";
import useCopayScheduleNotes from "./hooks/useCopayScheduleNotes";

const CopayScheduleNote = () => {
  const location = useLocation();
  const [stateVal, setStateVal] = useState(location?.state || []);
  const { currentState, previousState } = useMemo(() => {
    let [currentState = {}] = [...stateVal].reverse();
    const previousState = [...stateVal];
    previousState.splice(stateVal.length - 1, 1);
    return { currentState, previousState };
  }, [stateVal]);
  const {
    selectedCopaySchedules = [],
    previousScreen = ROUTE_PATHS.OUT_OF_POCKET_MAX_SCHEDULE,
    currentIndex: initialIndex = 0,
  } = currentState;
  console.log(
    "states",
    stateVal,
    currentState,
    selectedCopaySchedules,
    initialIndex,
    previousState
  );
  const navigateToPage = useCustomNavigate();
  const [externalMode, setExternalMode] = useState(false);
  const {
    notes,
    newNotes,
    mode,
    first,
    rows,
    totalRecords,
    currentIndex,
    setMode,
    setFirst,
    setRows,
    setCurrentIndex,
    handleSaveNotes,
    handleChangeNewNote,
    onPageChange,
    exportAsCSV,
  } = useCopayScheduleNotes(selectedCopaySchedules, initialIndex);

  const screen_title = "Copay Schedule Note";
  const screen_code = "RCCSN001";

  const columns =
    mode === "view"
      ? [
          { key: "csnNote", header: "Note" },
          { key: "chgDate", header: "Added Date" },
          { key: "chgTime", header: "Added Time" },
          { key: "chgUserName", header: "User" },
        ]
      : [{ key: "csnNote", header: "Note" }];

  const handleBack = useCallback(() => {
    if (externalMode) {
      const message = {
        message: "navigate-to-external-program",
        url: previousScreen,
        parameters: {
          state: [...previousState],
        },
      };
      window.parent.postMessage(message, "*");
    } else if (currentIndex < selectedCopaySchedules.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      navigateToPage(previousScreen, previousState);
    }
  }, [currentIndex, navigateToPage, setCurrentIndex]);

  const handleBackAndSetMode = useCallback(() => {
    handleBack();
    setMode("view");
  }, [handleBack, setMode]);

  const handleModeSwitch = useCallback(() => {
    if (mode === "add") {
      setMode("view");
    } else if (mode === "view") {
      setMode("add");
    }
  }, [mode]);

  const leftButtons = useMemo(
    () => [
      {
        button_label: "Back",
        button_handeler: handleBackAndSetMode,
        button_key: "F12",
      },
      ...(mode === "add"
        ? [
            {
              button_label: "View Note",
              button_handeler: handleModeSwitch,
              button_key: "F6",
            },
          ]
        : []),
    ],
    [mode, handleBackAndSetMode, handleModeSwitch]
  );

  const rightButtons = useMemo(
    () => [
      ...(mode === "view"
        ? [
            {
              button_label: "Add Note",
              button_handeler: handleModeSwitch,
              button_key: "F6",
            },
          ]
        : []),
      { button_label: "Export as CSV", button_handeler: exportAsCSV },
    ],
    [mode]
  );

  const getName = (selectedCopaySchedules, currentIndex) => (
    <>
      <strong>Copay Schedule </strong>
      {selectedCopaySchedules[currentIndex].cshCopayScheduleId}
      <span className="info-records">
        <strong> Description </strong>
        {selectedCopaySchedules[currentIndex].cshCopayScheduleDesc}
      </span>
    </>
  );

  useEffect(() => {
    const handleMessage = (event) => {
      const { type, data } = event.data;
      if (type === "set-params") {
        setStateVal(data);
        setExternalMode(true);
      }
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return (
    <div className="container">
      <ButtonsSection ctaButtons={leftButtons} align="left" />
      <div className="left-aligned-section">
        <div className="header-section">
          <h1>
            {screen_title} - <span className="heading-cod">{screen_code}</span>
          </h1>
        </div>
        <p className="head-name">
          {selectedCopaySchedules?.length > 0 && getName(selectedCopaySchedules, currentIndex)}
        </p>
      </div>
      <div className="button-sections">
        <ButtonsSection ctaButtons={rightButtons} align="right" />
      </div>
      <NoteTable
        data={notes}
        columns={columns}
        mode={mode}
        newNotes={newNotes}
        handleChangeNewNote={handleChangeNewNote}
        handleSaveNotes={handleSaveNotes}
      />
      <NextGenPaginator
        first={first}
        rows={rows}
        totalRecords={totalRecords}
        currentPage={first / rows}
        rowsPerPageOptions={[10, 25, 50]}
        onPageChange={onPageChange}
      />
    </div>
  );
};

export default CopayScheduleNote;
